import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useRetention } from '../RetentionContext';
import { getDemo } from '../../../redux/features/retentionSlice';

// Stages 4–7 all read GET /retention/:id/demo (loaded by the Onboarding and Demo tabs). `run` dispatches a write,
// shows the server's message and reloads the demo data + the stepper on success.
export default function useDemoData() {
  const { courseEnrollmentId, refresh } = useRetention();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { demo, saving } = useSelector((state) => state.retention);

  const reload = useCallback(() => {
    dispatch(getDemo(courseEnrollmentId));
    refresh();
  }, [dispatch, courseEnrollmentId, refresh]);

  const run = useCallback(
    async (action, okMessage = 'Saved') => {
      const res = await dispatch(action);
      const ok = res.payload?.status === 'success';
      enqueueSnackbar(res.payload?.message || (ok ? okMessage : 'Could not save'), { variant: ok ? 'success' : 'error' });
      if (ok) reload();
      return ok;
    },
    [dispatch, enqueueSnackbar, reload],
  );

  return { d: demo.data, demo, saving, reload, run, courseEnrollmentId };
}

// The subject's attempt that stages 5–6 work on: the latest one, once a tutor is confirmed and it isn't closed.
export const openAttempt = (subject) => {
  const a = subject?.latest_attempt;
  return a && Number(a.mapping_status) === 2 && !a.closed_at ? a : null;
};
